import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "assets/css/export_import.css";
import {
  Typography,
  Grid,
  FormControl,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
} from "@material-ui/core";



import { useQuery, useMutation, useQueryClient } from "react-query";
import * as api from "../../../actions/api";

import {Clear, CloudUploadOutlined, PictureAsPdf,PermMediaOutlined,Add  } from "@material-ui/icons";
import LoaderForGlobal from "services/LoaderForGlobal";

import { useTranslation } from "react-i18next";
import Autocomplete from '@material-ui/lab/Autocomplete';
import swal from "sweetalert";
import * as Service from "../../../services/Service.js";
import { setYear } from "date-fns";
import ImageModal from "./ImageModal";
import SupplierModal from "./SupplierModal";
import NationalSupplier from "../nationalsupplier/NationalSupplier";

const ProductSpecificationFormData = (props) => {
  const classes = useStyles();
//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "product-specification-report";
const UserInfo = sessionStorage.getItem("User_info")
  ? JSON.parse(sessionStorage.getItem("User_info"))
  : 0;
  const UserName = UserInfo == 0 ? "" : UserInfo[0].id;

const DistrictList = JSON.parse(localStorage.getItem("DistrictList"));

const SupplierListNational = JSON.parse(localStorage.getItem("SupplierListNational"));
const ManufacturerListNational = JSON.parse(localStorage.getItem("ManufacturerListNational"));

const IndentorList = JSON.parse(localStorage.getItem("IndentorList"));
const PackageYearList = JSON.parse(localStorage.getItem("PackageYearList"));
const PackageList = JSON.parse(localStorage.getItem("PackageList"));
const CurrencyIdList = JSON.parse(localStorage.getItem("CurrencyList"));
const EstimatedCurrencyList = JSON.parse(localStorage.getItem("EstimatedCurrencyList"));
const [currYearId, setcurrYearId] = useState(0);

const GlobalSettings = JSON.parse(localStorage.getItem("GlobalSettings"));
const [buttonDisabled, setbuttonDisabled] = useState(true);
const [buttonDisabledProduct, setbuttonDisabledProduct] = useState(true);
const [CertificateUploadedFileName, setCertificateUploadedFileName] = useState();
const [CertificateUploadedFileNameProduct, setCertificateUploadedFileNameProduct] = useState();
const [ErrorMgsCertificate, setErrorMgsCertificate] = useState();
const [ErrorMgsCertificateProduct, setErrorMgsCertificateProduct] = useState();
const [OldCertificateUploadedFileName, setOldCertificateUploadedFileName] = useState();
const [isLoading, setLoading] = useState(false);
const [isLoadingProduct, setLoadingProduct] = useState(false);
const [ErrorMsgShowing, setErrorMsgShowing] = useState(false);
const [ErrorMsgShowingProduct, setErrorMsgShowingProduct] = useState(false);

const [ShowErrorMsg, setShowErrorMsg] = useState();
const [ShowErrorMsgProduct, setShowErrorMsgProduct] = useState();

const removeStrFromURL = process.env.REACT_APP_API_URL;
const REPORT_URL = removeStrFromURL.replace('backend/', '');

const [uploadFormData, setFormData] = useState({
  menukey: menukey,
  lan: lan,
  UserName: UserName,
  BrandNo: "",// Need to change
  CertificateName: "",
  BrandCode: "",
  ManufacturerId: "",
  DateExpiration: "",
  UploadStatus: "",
  UploadStatusProduct: "",
  ProductImage: "",
  Specification:""
});

  const { t, i18n } = useTranslation();

  
const CureentYearList =JSON.parse(localStorage.getItem("CureentYearList"));

const currentValue = (CureentYearList[0].id);
const currentYearName = (CureentYearList[0].name);

const [CurentsYearId, setYearIdData] = useState(currentValue);
const [formDisable, setFormDisable] = useState(false);
const [imageArray, setImageArray] = useState([]);


//====== Start Choosen Dropdown===========
const [chosenValues, setChosenValues] = useState({
 // "PackageNo": {"PackageNo": "","PackageName": ""},
  
 "YearId": {"YearId": currentValue,"PackageYear": currentYearName},

  "CurrencyId": {"CurrencyId": "","CurrencyName": "","ConvRate": ""},
  "EstimatedCurrencyId": {"EstimatedCurrencyId": "","EstimatedCurrencyName": ""},
  "SupCode": {"SupCode": "","SupName": ""},
  "ManufacturerId": {"ManufacturerId": "","ManufacturerName": ""},
});


const [chosenValuesFacility, setChosenValuesFacility] = useState({
  "PackageNo": {"PackageNo": "","PackageName": ""}
});


const [chosenValuesCurrency, setChosenValuesCurrency] = useState({
  "CurrencyId": {"CurrencyId": "","CurrencyName": "","ConvRate": ""}
});


useEffect(() => {
  
  let chosenValuesData = { ...chosenValues};
  // chosenValuesData['IndentorId'] = IndentorList[IndentorList.findIndex(Indentor_List => Indentor_List.IndentorId == formData.IndentorId)];
  
  
  chosenValuesData['YearId'] = PackageYearList[PackageYearList.findIndex(PackageYear_List => PackageYear_List.YearId == props.formData.YearId)];
   chosenValuesData['CurrencyId'] = CurrencyIdList[CurrencyIdList.findIndex(CurrencyId_List => CurrencyId_List.CurrencyId == props.formData.CurrencyId)];
   chosenValuesData['EstimatedCurrencyId'] = EstimatedCurrencyList[EstimatedCurrencyList.findIndex(EstimatedCurrency_List => EstimatedCurrency_List.EstimatedCurrencyId == props.formData.EstimatedCurrencyId)];
   chosenValuesData['SupCode'] = SupplierListNational[SupplierListNational.findIndex(NationalSupplier_List => NationalSupplier_List.SupCode == props.formData.SupCode)];
   chosenValuesData['ManufacturerId'] = ManufacturerListNational[ManufacturerListNational.findIndex(ManufacturerId_List => ManufacturerId_List.ManufacturerId == props.formData.ManufacturerId)];
   setChosenValues(chosenValuesData);  

    
   if(props.formData.Specification!="") {
    uploadFormData["CertificateName"] = props.formData.Specification;
    uploadFormData["UploadStatus"] = 'FileUpload';
   }
   if((props.formData.ProductImage!="")) { 
    if(props.formData.ProductImage!=null){
    
    uploadFormData["ProductImage"] = props.formData.ProductImage.split('|');
    uploadFormData["UploadStatusProduct"] = 'FileUpload';
    let imagename=props.formData.ProductImage.split('|');
    let row=[];
    for(let i=0;i<imagename.length;i++){     
      row.push(REPORT_URL+'/media/CatalogDoc/'+imagename[i]);   

    }  
    setImageArray(row); 
    }
   }

  //  setImageArray(props.formData.ProductImage);

  }, [props.formData.YearId,props.formData.CurrencyId]);
   


  React.useEffect(() => {
  
    let chosenValuesDataFacility = { ...chosenValuesFacility};
    chosenValuesDataFacility['PackageNo'] = PackageList[PackageList.findIndex(Package_List => Package_List.PackageNo == props.formData.PackageNo)];
    setChosenValuesFacility(chosenValuesDataFacility); 
  }, [props.formData.PackageNo]);


/*  

const handleChangeChoosen = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData[name] = valueobj;   
  setChosenValues(chosenValuesData); 
  props.handleChangeChoosenProps(name, value);
};

*/

const handleChangeChoosen = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData[name] = valueobj;   
  setChosenValues(chosenValuesData);

    if(name=='CurrencyId') {
      if(value==1){
        
        setFormDisable(true);
      }else{ 
        setFormDisable(false);
      }
    
    } 

  let chosenValuesDataFacility = { ...chosenValuesFacility};
  chosenValuesDataFacility[name] = valueobj;  
  setChosenValuesFacility(chosenValuesDataFacility); 

  props.handleChangeChoosenProps(name, value);
};


const handleChangeYearDependency = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData[name] = valueobj;   
  //props.formData["PackageNo"] = "";

  setChosenValues(chosenValuesData);
  setcurrYearId(value);

  props.handleChangeChoosenProps(name, value);

};

React.useEffect(() => { 
  if(props.formData.YearId !==''){
    setcurrYearId(props.formData.YearId);
  }
   
}, [props.formData.YearId]);


React.useEffect(() => {
  cPackageList();
}, [currYearId]);

//====== End Choosen Dropdown===========

let TempItemList = useState([]);
const [ItemList, setItemListLocal] = useState(TempItemList);

const cPackageList = () => {

  let PackageListParam = { action: "getPackegeListCatalog", YearId: currYearId, menukey: "",userId:UserInfo[0].id }

  Service.default
    .postApi("source/combo_catalog.php", PackageListParam)
    .then((res) => {

      if(!props.addProductForm){
        let chosenValuesDataFacility = { ...chosenValuesFacility};
        chosenValuesDataFacility['PackageNo'] = res.datalist[res.datalist.findIndex(fpacily_Lists2 => fpacily_Lists2.PackageNo == props.formData.PackageNo)];
        setChosenValuesFacility(chosenValuesDataFacility);  

      }else{
        setChosenValuesFacility({
        "PackageNo": {"PackageNo": "","PackageName": ""}
        }); 
        props.formData["PackageNo"] = "";
      } 

      setItemListLocal(res.datalist);


    })
    .catch((err) => { });

}


const backtolist=()=>{


  let master_dirty_message_class = document.getElementById("master_dirty_message").getAttribute("class"); 
  let idx = master_dirty_message_class.indexOf("dnone");
  if(idx === -1){
    // start Alert
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(DispensingLanguage[lan][menukey]["You have unsaved changes which will be lost. Continue?"]),
      icon: "warning",
      buttons: {
        confirm: {
          text: t(DispensingLanguage[lan][menukey]["Yes"]),
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
        cancel: {
          text: t(DispensingLanguage[lan][menukey]["No"]),
          value: null,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
    }).then((willAction) => {
      if (willAction) {
        props.history.push("/product-specification-report");
      }
    });
    // End Alert
  }else{
    props.history.push("/product-specification-report");
  }

}




/* =============Certificate=========== */


const {  mutate: mutateBrandData } = useMutation(api.getBrandDataById, {
  onSuccess: (data) => { 
    if (data.status === 200) { 

      setFormData(data.data);
      setOldCertificateUploadedFileName(data.data.CertificateName);
    }
  }
});
const getBrandData = () => {

  let params={
    action:"getBrandDataById",
    menukey: menukey, 
    BrandNo: "", // need to change
  };
  mutateBrandData(params);
};

const APP_URL = process.env.REACT_APP_API_URL;

const changeHandlerForCertificate = (event,action) => {
//console.log(event.target.files);
  let selectedFile;
  let FileName;
  let FileExt;
  let Filetype;
  let fileSizeNum;
 
 

switch(action){
  case 'Specification':

    selectedFile = event.target.files[0];
    if(selectedFile == undefined){
      return;
    }

     FileName = selectedFile.name;
     FileExt = FileName.split(".").pop();
     Filetype = FileExt.toLowerCase();
     fileSizeNum = selectedFile.size;
  
    setErrorMsgShowing(false);
    setLoading(true);
    setbuttonDisabled(false);
  
   
  
    //File size Greater then 5MiB!
    // const fileSizeNum = selectedFile.size / 1024 / 1024; // in MiB
    // const fileSize = fileSizeNum.toFixed(2);
  
    //The file Check extension
    if (Filetype == "pdf" || Filetype == "PDF") {
      if(fileSizeNum<=5242880){

        setErrorMgsCertificate("");
        handleUploadFile(action,selectedFile);
      }else{
        setErrorMgsCertificate(
          DispensingLanguage[lan][menukey]["Sorry, file more than 5MB is not allowed"]
        ); 
        setbuttonDisabled(true);
        setLoading(false);

      }
    } else {
      setErrorMgsCertificate(
        DispensingLanguage[lan][menukey]["Sorry, only pdf file are allowed"]
      );
      // setCertificateUploadedFileName("");
      // uploadFormData["CertificateName"] = "";
      setbuttonDisabled(true);
      setLoading(false);
    }

  break;
  case 'ProductName':
    
    selectedFile = event.target.files; 
    console.log(selectedFile);
    if(selectedFile == undefined){
      return;
    }

    let rows = [];
    for(let i=0;i<selectedFile.length;i++){

      let fileinfo=selectedFile[i];
 console.log(fileinfo); 
      // let newRow={} ;
      // newRow.ItemNo =row.ItemNo;
       
      // rows.push(newRow);


      FileName = fileinfo.name;
      FileExt = FileName.split(".").pop();
      Filetype = FileExt.toLowerCase();
      fileSizeNum = fileinfo.size;
      setErrorMsgShowing(false);
      setLoadingProduct(true);
      setbuttonDisabledProduct(false); 
    
      //File size Greater then 5MiB!
      // const fileSizeNum = selectedFile.size / 1024 / 1024; // in MiB
      // const fileSize = fileSizeNum.toFixed(2);
    
      //The file Check extension
      if (Filetype == "jpeg" || Filetype == "png" || Filetype == "jpg") {
     
       
  
  
        if(fileSizeNum<=5242880){
  
          setErrorMgsCertificateProduct("");
         
        }else{
          setErrorMgsCertificateProduct(
            DispensingLanguage[lan][menukey]["Sorry, file more than 5MB is not allowed"]
          ); 
          setbuttonDisabledProduct(true);
          setLoadingProduct(false);
          return;
        }
  
  
      } else {
        setErrorMgsCertificateProduct(
          DispensingLanguage[lan][menukey]["Sorry, only image file are allowed"]
        );
        // setCertificateUploadedFileName("");
        // uploadFormData["CertificateName"] = "";
        setbuttonDisabledProduct(true);
        setLoadingProduct(false);
        return;
      }
      if(selectedFile.length-1==i)
      handleUploadFile(action,selectedFile);
    
  

    }
     
    
  break;
}
 

  
};



const handleUploadFile = async (action,selectedFile) => {
  handleFileUploadForCertificate(action,selectedFile);

  /*
  swal({
    title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
    text: t(DispensingLanguage[lan][menukey]["Confirm Certificate PDF File Upload"]),
    icon: "warning",
    buttons: [t(DispensingLanguage[lan][menukey]["No"]), 
    t(DispensingLanguage[lan][menukey]["Yes"])],
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      
    }else{
      uploadFormData["CertificateName"] = OldCertificateUploadedFileName;
      uploadFormData["UploadStatus"] = '';
      setCertificateUploadedFileName('');
      
      setLoading(false);
      setbuttonDisabled(true);
    }
  });*/
};


const handleFileUploadForCertificate = (action,selectedFile) => { 

if((chosenValues['YearId']==undefined)||(chosenValuesFacility['PackageNo']==undefined)){
  props.openNoticeModal({
    isOpen: true,
    msg: DispensingLanguage[lan][menukey]["Please fill year and Package first"],
    msgtype: false,
  });
  setLoading(false);
  return;
}else if(chosenValuesFacility['PackageNo'].PackageNo==''){
  props.openNoticeModal({
    isOpen: true,
    msg: DispensingLanguage[lan][menukey]["Please fill year and Package first"],
    msgtype: false,
  });
  setLoading(false);
  return;
  
}

let ItemCode=props.formData.ItemCode==undefined?props.match.params.id:props.formData.ItemCode;
 let PackageName=PackageList[PackageList.findIndex(Package_List => Package_List.PackageNo == props.formData.PackageNo)].PackageName;
 let Year=PackageYearList[PackageYearList.findIndex(PackageYear_List => PackageYear_List.YearId == props.formData.YearId)].PackageYear;
  
  const formData = new FormData();
  
  if(action=='ProductName')
  for(let i=0;i<selectedFile.length;i++){
    formData.append('FileName[]', selectedFile[i]); 
  }
  else
  formData.append("FileName", selectedFile);
 
  formData.append("ItemCode",ItemCode);
  formData.append("PackageNo", PackageName);
  
  formData.append("YearId", Year);
  formData.append("Action", action);
  //let authCertPath = GlobalSettings.auth_cert;
  //formData.append("authCertPath", authCertPath);


  
  let finalUrl = APP_URL + "upload/specification_upload.php";
  switch(action){
    case 'Specification':
     
          
        fetch(finalUrl, {
          method: "POST",
          body: formData,
         
        })
          .then((response) => response.json())
          .then((res) => {
            if (res.msgType == "success") {
            
              setCertificateUploadedFileName(res.FileName);
              uploadFormData["CertificateName"] = res.FileName;
              uploadFormData["UploadStatus"] = 'FileUpload';

              props.formData.Specification=res.FileName;
              props.formData.SpecificationHidden=2;
              setErrorMgsCertificate("");
              //handleSubmit();

            } else {
              setErrorMgsCertificate(res.msg);
            }
            setLoading(false);
          })
          .catch((error) => {
            setErrorMgsCertificate(error);
            setLoading(false);
          });
        break;
        case 'ProductName':
         
      
            fetch(finalUrl, {
              method: "POST",
              body: formData, 
             // headers: { 'Content-Type': 'multipart/form-data' }
            })
              .then((response) => response.json())
              .then((res) => {
                if (res.msgType == "success") {
                
                  setCertificateUploadedFileNameProduct(res.AllImageName);
                  uploadFormData["ProductImage"] = res.ImageNames;
                  uploadFormData["UploadStatusProduct"] = 'FileUpload';
                 
                  props.formData.ProductImage=res.AllImageName;
                  props.formData.ProductImageHidden=2;
                  setErrorMgsCertificateProduct("");
                  //handleSubmit();
    
                } else {
                  setErrorMgsCertificateProduct(res.msg);
                }
                setLoadingProduct(false);
              })
              .catch((error) => {
                setErrorMgsCertificateProduct(error);
                setLoadingProduct(false);
              });
            break;
  }
   


  };

/*
  const { mutate } = useMutation(api.UploadCertificate, {
    onSuccess: (data) => {
      let msg = data.message;
      if (data.success == 1) {
        getBrandData();
        swal(msg, "", "success");
  
      } else {
        setShowErrorMsg(msg);
        setErrorMsgShowing(true);
      }
      
      uploadFormData["CertificateName"] = "";
      uploadFormData["UploadStatus"] = '';
      setCertificateUploadedFileName("");
      
      setLoading(false);
      setbuttonDisabled(true);
    },
  });
*/


/*
  const handleSubmit = (data) => {
    setLoading(true);
    setbuttonDisabled(true);
    mutate(uploadFormData);
  }

*/
  const UploadFileDownload = (uploadFile,action) => {
    
   // let authCertPath = GlobalSettings.auth_cert;//REPORT_URL + authCertPath+
    let imgUrl="";
    if(action=='Specification'){
      if((uploadFormData["CertificateName"]=="")||(uploadFormData["CertificateName"]==undefined))
       imgUrl=REPORT_URL+'/media/CatalogDoc/'+uploadFile;
      else  
       imgUrl=REPORT_URL+'/media/CatalogDoc/'+uploadFile;   
    }else{
      if((uploadFormData["ProductImage"]=="")||(uploadFormData["ProductImage"]==undefined))
       imgUrl=REPORT_URL+'/media/CatalogDoc/'+uploadFile;
      else  
       imgUrl=REPORT_URL+'/media/CatalogDoc/'+uploadFile; 
    }
    
    let finalUrl = imgUrl;
  
    // let finalUrl = REPORT_URL + "writable_files/auth_cert/"+uploadFile;
    if(action=='Specification') {
      window.open(finalUrl);
    }else{
      // SetImageName({ItemName:props.formData.ItemName,ProductImage:imgUrl});
      let SYearName = PackageYearList[PackageYearList.findIndex(PackageYear_List => PackageYear_List.YearId == props.formData.YearId)].PackageYear;
      let SPackageName=PackageList[PackageList.findIndex(Package_List => Package_List.PackageNo == props.formData.PackageNo)].PackageName;
      //console.log("Year Name",SYearName);
      SetImageName({ItemName:props.formData.ItemName,ProductImage:imgUrl,ImageArray:imageArray,YearName:SYearName,PackageName:SPackageName});

      

      handleModal("ImageOpen");
    }
    

    

  };

  const DeleteUploadFile = async (e,action,filename) => {

    
    if(action=="Specification"){
      uploadFormData["CertificateName"] = "";
      uploadFormData["UploadStatus"] = 'FileDelete';
      setCertificateUploadedFileName("");
      props.formData.SpecificationHidden=1; 
      props.formData.Specification="";   
    // handleSubmit();  
      setbuttonDisabled(false);

    }else{

      uploadFormData["ProductImage"] = "";
      uploadFormData["UploadStatusProduct"] = 'FileDelete';
      setCertificateUploadedFileNameProduct("");  
      props.formData.ProductImageHidden=1;

      let imgMap=props.formData.ProductImage.split('|');
      for(let i=0;i<imgMap.length;i++){

        
      }
      props.formData.ProductImage="";//CertificateUploadedFileNameProduct;
       
    // handleSubmit();  
      setbuttonDisabledProduct(false);

    }
    
  

  //  onConfirmDeleteUploadFile(action);
    // swal({
    //   title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
    //   text: t(DispensingLanguage[lan][menukey]["Once deleted, you will not be able to recover this PDF File!"]),
    //   icon: "warning",
    //   buttons: [t(DispensingLanguage[lan][menukey]["No"]), 
    //   t(DispensingLanguage[lan][menukey]["Yes"])],
    //   dangerMode: true,
    // }).then((willDelete) => {
    //   if (willDelete) {
        
    //   }
    // });
  };


 // const onConfirmDeleteUploadFile = (action) => {}

  /*
  useEffect(() => {
    getBrandData();
  
  }, [BrandNo]);

  */

  const handleUpdate = (e,action) => {
     
    if((chosenValues['YearId']==undefined)||(chosenValuesFacility['PackageNo']==undefined)){
      if(action=="Save")
      props.handleSubmit();
      else
      props.handleUpdate();
    }
    else if(chosenValuesFacility['PackageNo'].PackageNo==''){

      if(action=="Save")
      props.handleSubmit();
      else
      props.handleUpdate();

    }
    if((uploadFormData["CertificateName"]=="")||(uploadFormData["CertificateName"]==undefined)){
      setErrorMgsCertificate("field is Required !");
    }else{
      if(action=="Save")
      props.handleSubmit();
      else
      props.handleUpdate();
    }
   
    
  }


  
function srcset(image, size, rows = 1, cols = 1) {

  if((uploadFormData["ProductImage"]=="")||(uploadFormData["ProductImage"]==undefined))
  image=REPORT_URL+'/media/CatalogDoc/'+image;
  else  
  image=REPORT_URL+'/media/CatalogDoc/'+image;
  
  return {
    src: `${image}`,
    // src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    // srcSet: `${image}?w=${size * cols}&h=${
    //   size * rows
    // }&fit=crop&auto=format&dpr=2 2x`
  };

  
}

const addSupplier = (SupplierData) => {

console.log("oooooooooooooo");
  

 };
 
const [openImage, setOpenImage] = useState(false);
const [imageName, SetImageName] = useState('');


const [SupplierOpen, setSupplierOpen] = useState(false);

const handleModal = (modalname) => {
  switch (modalname) {
     

      case "ImageModal":
        setOpenImage(false);
        break;
      case "ImageOpen":
        setOpenImage(true);
        break;  

      case "SupplierModal":
        setSupplierOpen(false);
        break;

      case "SupplierOpen":
        setSupplierOpen(true);
        break;

    default:
      break;
  }
};

return (
  <div className={classes.productPageTitle}>
    <div className="sw_makeStyles_tableContainer">
      <div className="d-flex justify-product mb-3">
        <Grid item xs={12} sm={12}>
          <div className="sw_page_heading">
            <div className="sw_heading_title">
              {DispensingLanguage[lan][menukey]["Product Specification Entry Form - Add/Edit"]}
            </div>
            </div>
            <div className="float-right sw_btn_control">
              {props.addProductForm ? (
                <Grid item xs={12} className="text-center">
                  <div className="float-right sw_btn_control">
                    <Button
                      disabled={props.bStockUpdate}
                      className="mr-2"
                      variant="contained"
                      type="reset"
                      onClick={() => props.handleReset()}
                    >
                      {DispensingLanguage[lan][menukey]["Reset"]}
                    </Button>
                    <Button
                      disabled={props.bStockUpdate}
                      className="mr-2"
                      variant="contained"
                      color="primary"
                      onClick={(e) => handleUpdate(e,'Save')}
                    >
                      {DispensingLanguage[lan][menukey]["Save"]}
                    </Button>
                    <Button
                      className="mr-2"
                      variant="contained"
                      type="reset"
                      //onClick={() => props.history.push("/menu-entry")}
                      onClick={() => backtolist()}
                    >
                      {DispensingLanguage[lan][menukey]["Back to List"]}
                    </Button>
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} className="mt-2 text-center">
                

                  <Button
                    className="mr-2"
                    variant="contained"
                    type="reset"
                    //onClick={() => props.history.push("/menu-entry")}
                    onClick={() => backtolist()}
                  >
                    {DispensingLanguage[lan][menukey]["Back to List"]}
                  </Button>
                </Grid>
              )}
            </div>
          
             <div className="mr-4 float-right mt-15">
              <span id="master_dirty_message" className={'masterredtextcolor dnone'}> {DispensingLanguage[lan][menukey]["You have unsaved changes"]}</span>
            </div>
        </Grid>
      </div>

      {/* New row */}
      <Grid container spacing={3}>
        {/* New row */}
        <Grid item xs={12} sm={12}>
          {/* <Card className="sw_card">
            <CardContent> */}
               <Grid container spacing={4}>
                  {/* <Grid item xs={6} sm={5}>
                    <FormControl className={classes.fullWidth}>
                      
                          <Autocomplete
                            autoHighlight
                            id="IndentorId"
                            disabled={props.bStockUpdate}
                            options={IndentorList}
                            onChange={(event, valueobj) => handleChangeChoosen('IndentorId', valueobj, valueobj?valueobj.IndentorId:"")}
                            getOptionLabel={(option) => option.IndentorName +' - '+ option.OPDescription}
                            value={chosenValues['IndentorId']}
                            renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.IndentorName +' - '+ option.OPDescription}</Typography>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              value={formData.IndentorId}
                              label={DispensingLanguage[lan][menukey]["Indentor Name"]}
                              variant="standard"
                              error={errorObject.IndentorId}
                              helperText={errorObject.IndentorId}
                              id="IndentorId"
                              name="IndentorId"
                              fullWidth
                            />
                            )}
                          />

                    </FormControl>
                  </Grid> */}



                      <Grid item xs={2} sm={2}>
                        <TextField
                        
                          disabled={true}
                          error={props.errorObject.ItemCode}
                          helperText={props.errorObject.ItemCode}
                          required
                          id="ItemCode"                        
                          name="ItemCode"
                          label= {DispensingLanguage[lan][menukey]['Item Code'] }
                          value={props.formData.ItemCode}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => props.handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={7} sm={7}>
                        <TextField
                        
                          disabled={true}
                          error={props.errorObject.ItemName}
                          helperText={props.errorObject.ItemName}                         
                          required
                          id="ItemName"
                          name="ItemName"
                          label= {DispensingLanguage[lan][menukey]['Item Name'] }
                          value={props.formData.ItemName}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => props.handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={3} sm={3}>
                        <TextField
                        
                          disabled={true}
                          error={props.errorObject.UnitName}
                          helperText={props.errorObject.UnitName}
                          required
                          id="UnitName"                        
                          name="UnitName"
                          label= {DispensingLanguage[lan][menukey]['Unit'] }
                          value={props.formData.UnitName}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => props.handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                      

                        <Autocomplete
                            autoHighlight
                            id="YearId" 
                            disabled={true}
                            options={PackageYearList}
                            onChange={(event, valueobj) => handleChangeYearDependency('YearId', valueobj, valueobj?valueobj.YearId:"")}
                            getOptionLabel={(option) => option.PackageYear}
                            //value={chosenValuesFacility['YearId']}
                            value={chosenValues['YearId']}
                            renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.PackageYear}</Typography>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              value={props.formData.YearId}
                              label={DispensingLanguage[lan][menukey]["Year"]}
                              variant="standard"
                              error={props.errorObject.YearId}
                              helperText={props.errorObject.YearId}
                              id="YearId"
                              name="YearId"
                              fullWidth
                            />
                            )}
                          />

                    </FormControl>
                  </Grid>


                  <Grid item xs={5} sm={5}>
                    <FormControl className={classes.fullWidth}>
                      

                        <Autocomplete
                            autoHighlight
                            id="PackageNo" 
                            disabled={true}
                            options={ItemList}
                            onChange={(event, valueobj) => handleChangeChoosen('PackageNo', valueobj, valueobj?valueobj.PackageNo:"")}
                            getOptionLabel={(option) => option.PackageName}
                            //value={chosenValues['PackageNo']}
                            value={chosenValuesFacility['PackageNo']}
                            renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.PackageName}</Typography>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              value={props.formData.PackageNo}
                              label={DispensingLanguage[lan][menukey]["Package"]}
                              variant="standard"
                              error={props.errorObject.PackageNo}
                              helperText={props.errorObject.PackageNo}
                              id="PackageNo"
                              name="PackageNo"
                              fullWidth
                            />
                            )}
                          />

                    </FormControl>
                  </Grid>


                  <Grid item xs={5} sm={5}>
                        <TextField
                        
                          disabled={true}
                          error={props.errorObject.LotNo}
                          helperText={props.errorObject.LotNo}
                          
                          id="LotNo"                        
                          name="LotNo"
                          label= {DispensingLanguage[lan][menukey]['Lot No'] }
                          value={props.formData.LotNo}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => props.handleChange(e)}
                        />
                      </Grid>





                  <Grid item xs={6} sm={6}>
                            {/* ====Upload Box=== */}
                            <div className="tp-upload-box marginTopBottompp">
                              <div className="text-right sw_relative">
                                {isLoading && <LoaderForGlobal />}
                              </div>

                              <div className="tp-body">
                                <label class="label-ctm" for="CertificateName_selectFile">
                                  <b>{DispensingLanguage[lan][menukey]["Specification Image"]}*</b>
                                  </label>
                                {/* <div className="tp-file-upload">
                                  <input
                                    type="text"
                                    name="CertificateName_selectFile"
                                    id="CertificateName_selectFile"
                                    value={CertificateUploadedFileName}
                                    placeholder={
                                      DispensingLanguage[lan][menukey]["Choose a file"]
                                    }
                                    className="tp-form-control"
                                    readOnly={true}
                                  />
                                  <div className="file_browse_box">
                                    <input
                                      type="file"
                                      accept=".pdf, .PDF"
                                      name="CertificateName"
                                      id="CertificateName"
                                      className="tp-upload"
                                      onChange={(e) => changeHandlerForCertificate(e,"Specification")} 
                                    />
                                    <label for="CertificateName" className="file_browse_icon">
                                      <span className="icon-upload">
                                        <CloudUploadOutlined />
                                      </span>
                                      {DispensingLanguage[lan][menukey]["Browse"]}
                                    </label>
                                  </div>
                                </div> */}
                                {/* <div className="selectFile text-left">
                                  <span className="red">{ErrorMgsCertificate}</span>
                                </div> */}
                                {uploadFormData.CertificateName && 
                                <div className="attachment_view_card pdf_view_card">
                                  {/* <Button
                                      className="delete_icon"
                                      onClick={(e) => DeleteUploadFile(e,'Specification',uploadFormData.CertificateName)}
                                    >
                                    <Clear />
                                  </Button> */}
                                  <div className="view_icon">
                                    <PictureAsPdf
                                      onClick={() => UploadFileDownload(uploadFormData.CertificateName,'Specification')}
                                    />  
                                  </div>
                                </div>
                                }
                              </div>
                            </div>
                            {/* ====Upload Box=== */}
                  </Grid>
                  
                 
                  <Grid item xs={6} sm={6}>
                            {/* ====Upload Box=== */}
                            <div className="tp-upload-box marginTopBottompp thumbnail_tp-upload-box">
                              <div className="text-right sw_relative">
                                {isLoadingProduct && <LoaderForGlobal />}
                              </div>

                              <div className="tp-body">
                                <label class="label-ctm" for="ProductImage_selectFile"><b> {DispensingLanguage[lan][menukey]["Product Image"]}</b></label>
                                
                                {/* <div className="tp-file-upload">
                                  <input
                                    type="text"
                                    name="ProductImage_selectFile"
                                    id="ProductImage_selectFile"
                                    value={CertificateUploadedFileNameProduct}
                                    placeholder={
                                      DispensingLanguage[lan][menukey]["Choose a file"]
                                    }
                                    className="tp-form-control"
                                    readOnly={true}
                                  />
                                  <div className="file_browse_box">
                                    <input
                                      type="file"
                                      multiple="multiple"
                                      accept=".png, .jpeg, .jpg"
                                      name="ProductImage"
                                      id="ProductImage"
                                      className="tp-upload"
                                      onChange={(e) => changeHandlerForCertificate(e,"ProductName")} 
                                    //  onChange={changeHandlerForCertificate("ProductName")}
                                    />
                                    <label for="ProductImage" className="file_browse_icon">
                                      <span className="icon-upload">
                                        <CloudUploadOutlined />
                                      </span>
                                      {DispensingLanguage[lan][menukey]["Browse"]}
                                    </label>
                                  </div>
                                </div> */}
                                <div className="selectFile text-left">
                                  <span className="red">{ErrorMgsCertificateProduct}</span>
                                </div>
                                {uploadFormData.ProductImage && uploadFormData.ProductImage!='' && 

                              uploadFormData.ProductImage!=null ?
                              (
                               
                              uploadFormData.ProductImage.map((item) => (
                                <div className="attachment_view_card thumbnail_view_card">
                                  {/* <Button
                                      className="delete_icon"
                                      onClick={(e) => DeleteUploadFile(e,'ProductImage',item)}
                                    >
                                    <Clear />
                                  </Button> */}

                                      <img
                                     {...srcset(
                                      
                                      item
                                      
                                      
                                      
                                      , 20, 1, 1)}
                                    // alt={item.title}
                                    loading="lazy"                                   
                                    onClick={() => UploadFileDownload(item,'ProductImage')}
                                  />


                                    
                                  



                                    {/* <PermMediaOutlined 
                                      onClick={() => UploadFileDownload(uploadFormData.ProductImage,'ProductImage')}
                                    />   */}
                                  </div>
                                

                              )) 
                              ):(<>
                              </>)



                                }
                              </div>
                             
                            </div>
                            {/* ====Upload Box=== */}
                  </Grid>

                  </Grid>

              {/* New Row */}


               
              <Grid container spacing={4}> 
                <Grid item xs={12} sm={12}>

                  <div className={classes.AdditionalFields}>Additional Fields</div>
                  <FormControl className={classes.fullWidth}>
                    <Grid container spacing={4}>
                      <Grid item xs={1} sm={1}>
                          <TextField
                            disabled={true}
                            error={props.errorObject.procQty}
                            helperText={props.errorObject.procQty}
                            inputProps={{min: 0, style: { textAlign: 'right' }}}
                            id="procQty"                        
                            name="procQty"
                            label= {DispensingLanguage[lan][menukey]['Proc. Qty'] }
                            value={props.formData.procQty}
                            fullWidth
                            autoComplete="family-name"
                            onChange={(e) => props.handleChange(e)}
                          />
                        </Grid>

                        <Grid item xs={3} sm={3}>
                          <TextField                        
                            disabled={true}
                            error={props.errorObject.EstUnitPrice}
                            helperText={props.errorObject.EstUnitPrice} 
                            inputProps={{min: 0, style: { textAlign: 'right' }}}
                            id="EstUnitPrice"
                            name="EstUnitPrice"
                            label= {DispensingLanguage[lan][menukey]['EstUnitPrice'] }
                            value={props.formData.EstUnitPrice}
                            fullWidth
                            autoComplete="family-name"
                            onChange={(e) => props.handleChange(e)}
                          />
                        </Grid>


                        <Grid item xs={2} sm={2}>

                        <Autocomplete
                          disabled={true}
                          autoHighlight
                          id="EstimatedCurrencyId"
                          options={EstimatedCurrencyList}
                          onChange={(event, valueobj) => handleChangeChoosen('EstimatedCurrencyId', valueobj, valueobj?valueobj.EstimatedCurrencyId:"")}
                          getOptionLabel={(option) => option.EstimatedCurrencyName}
                         // value={acValue}
                          value={chosenValues['EstimatedCurrencyId']}
                          renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.EstimatedCurrencyName}</Typography>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              value={props.formData.EstimatedCurrencyId}
                              label={DispensingLanguage[lan][menukey]["Currency"]}
                              variant="standard"
                              error={props.errorObject.EstimatedCurrencyId}
                              helperText={props.errorObject.EstimatedCurrencyId}
                              id="EstimatedCurrencyId"
                              name="EstimatedCurrencyId"
                              fullWidth
                            />
                          )}
                        />

                        </Grid>


                      <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}>
                        <Autocomplete
                          disabled={true}
                          autoHighlight
                          id="SupCode"
                          options={SupplierListNational}
                          onChange={(event, valueobj) => handleChangeChoosen('SupCode', valueobj, valueobj?valueobj.SupCode:"")}
                          getOptionLabel={(option) => option.SupName}
                         // value={acValue}
                          value={chosenValues['SupCode']}
                          renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.SupName}</Typography>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              value={props.formData.SupCode}
                              label={DispensingLanguage[lan][menukey]["Supplier"]}
                              variant="standard"
                              error={props.errorObject.SupCode}
                              helperText={props.errorObject.SupCode}
                              id="SupCode"
                              name="SupCode"
                              fullWidth
                            />
                          )}
                        />

                      </FormControl>

                  </Grid>

                  <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}>
                        <Autocomplete
                          disabled={true}
                          autoHighlight
                          id="ManufacturerId"
                          options={ManufacturerListNational}
                          onChange={(event, valueobj) => handleChangeChoosen('ManufacturerId', valueobj, valueobj?valueobj.ManufacturerId:"")}
                          getOptionLabel={(option) => option.ManufacturerName}
                         // value={acValue}
                          value={chosenValues['ManufacturerId']}
                          renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.ManufacturerName}</Typography>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              value={props.formData.ManufacturerId}
                              label={DispensingLanguage[lan][menukey]["Manufacturer"]}
                              variant="standard"
                              error={props.errorObject.ManufacturerId}
                              helperText={props.errorObject.ManufacturerId}
                              id="ManufacturerId"
                              name="ManufacturerId"
                              fullWidth
                            />
                          )}
                        />

                      </FormControl>

                      

                  </Grid>

                        

                        <Grid item xs={3} sm={3}>
                        <TextField                        
                          disabled={true}
                          error={props.errorObject.PurchasePrice}
                          helperText={props.errorObject.PurchasePrice}                         
                          inputProps={{min: 0, style: { textAlign: 'right' }}}
                          id="PurchasePrice"
                          name="PurchasePrice"
                          label= {DispensingLanguage[lan][menukey]['PurchasePrice'] }
                          value={props.formData.PurchasePrice}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => props.handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={3} sm={3}>
                                         

                          <Autocomplete
                            disabled={true}
                              autoHighlight
                              id="CurrencyId" 
                              options={CurrencyIdList}
                              onChange={(event, valueobj) => handleChangeChoosen('CurrencyId', valueobj, valueobj?valueobj.CurrencyId:"")}
                              getOptionLabel={(option) => option.CurrencyName}
                              //value={chosenValuesFacility['YearId']}
                              value={chosenValues['CurrencyId']}
                              renderOption={(option) => (
                              <Typography className="sw_fontSize">{option.CurrencyName}</Typography>
                              )}
                              renderInput={(params) => (
                              <TextField
                                {...params}
                                value={props.formData.CurrencyId}
                                label={DispensingLanguage[lan][menukey]["Currency"]}
                                variant="standard"
                                error={props.errorObject.CurrencyId}
                                helperText={props.errorObject.CurrencyId}
                                id="CurrencyId"
                                name="CurrencyId"
                                fullWidth
                              />
                              )}
                            />            
                                     
                      </Grid> 

                      <Grid item xs={3} sm={3}>
                            

                            <TextField                        
                            disabled={true}
                            error={props.errorObject.ExchangeRate}
                            helperText={props.errorObject.ExchangeRate}             
                            inputProps={{min: 0, style: { textAlign: 'right' }}}
                            id="ExchangeRate"
                            name="ExchangeRate"
                            label= {DispensingLanguage[lan][menukey]['ExchangeRate'] }
                            value={props.formData.ExchangeRate}
                            fullWidth
                            autoComplete="family-name"
                            onChange={(e) => props.handleChange(e)}
                          />
                          
                        </Grid> 


                        <Grid item xs={3} sm={3}> 
                            <TextField                        
                            disabled={true}
                            error={props.errorObject.TotalBDT}
                            helperText={props.errorObject.TotalBDT}             
                            inputProps={{min: 0, style: { textAlign: 'right' }}}
                            id="TotalBDT"
                            name="TotalBDT"
                            label= {DispensingLanguage[lan][menukey]['TotalBDT'] }
                            value={props.formData.TotalBDT}
                            fullWidth
                            autoComplete="family-name"
                            onChange={(e) => props.handleChange(e)}
                          />
                          
                        </Grid> 



                     </Grid> 

                  </FormControl>
                 </Grid>

                 
                      
 
                 <ImageModal
                  handleClose={handleModal}
                  openOrder={openImage}
                  addOrder={imageName}
                  {...props}
                />  
                        

                     
                     
  
                  </Grid>




            {/* </CardContent>
          </Card> */}
        </Grid>
      </Grid>
    </div>
  </div>
);
};

export default ProductSpecificationFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
  AdditionalFields: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "15px"
  },
  text_right: {
    textAlign: "right"
  }
});
